import { useState } from "react";
import Button from "../../../../Custom/Button/Button";
import CustomSelect from "../../globalno-dodavanje/CustomSelect";
import CustomSelectSimple from "../CustomSelectSimple";
import SelectStatus from "./SelectStatus";
import { useGlobalContext } from "../../../../../Context/Context";

const razloziAll = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10"];

const emptyFilterData = {
  radnoMesto: { id: -1, name: "" },
  razlog: "",
  status: "",
};

function Filtriranje({ setCurrentState, setFilteredData, allData, lookups }) {
  const [filterData, setFilterData] = useState(emptyFilterData);
  const { dictionary } = useGlobalContext();

  const handleChange = (newValue, field) => {
    setFilterData((prev) => ({ ...prev, [field]: newValue }));
  };

  const handleFiltriraj = () => {
    setFilteredData(
      allData.filter(
        (d) =>
          (filterData.radnoMesto.id == -1 ||
            d.workplace_id == filterData.radnoMesto.id) &&
          (filterData.razlog === "" || d.razlog === filterData.razlog) &&
          (filterData.status === "" || d.status === filterData.status),
      ),
    );
  };

  return (
    <div
      style={{ display: "flex", gap: "10px", justifyContent: "space-between" }}
    >
      <div style={{ width: "15vw" }}>
        <CustomSelect
          label={dictionary["radnoMesto"]}
          allValues={lookups.radna_mesta || []}
          selectedValue={filterData.radnoMesto}
          onSelectChange={(v) => handleChange(v, "radnoMesto")}
        />
      </div>
      <CustomSelectSimple
        label={dictionary["razlog"]}
        allValues={razloziAll}
        selectedValue={filterData.razlog}
        onSelectChange={(v) => handleChange(v, "razlog")}
        style={{ width: "5vw" }}
        isUp
      />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "end",
          gap: "10px",
        }}
      >
        <SelectStatus
          selectedValue={filterData.status}
          onSelectChange={(v) => handleChange(v, "status")}
          style={{ width: "5vw", height: "40px" }}
        />
        <div
          onClick={handleFiltriraj}
          style={{ width: "15vw", height: "40px" }}
        >
          <Button activation={true} style={{ fontWeight: "bold" }}>
            {dictionary["primeni"]}
          </Button>
        </div>
        <div
          onClick={() => {
            setCurrentState("");
            setFilteredData(allData);
          }}
          style={{ width: "15vw", height: "40px" }}
        >
          <Button activation={true} style={{ fontWeight: "bold" }}>
            {dictionary["odustani"]}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Filtriranje;
